import { render, staticRenderFns } from "./Tercerizados.vue?vue&type=template&id=66bf0c2e&scoped=true"
import script from "./Tercerizados.vue?vue&type=script&lang=js"
export * from "./Tercerizados.vue?vue&type=script&lang=js"
import style0 from "./Tercerizados.vue?vue&type=style&index=0&id=66bf0c2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bf0c2e",
  null
  
)

export default component.exports